import React from "react";

export default function Paragraph({ options, items, fontStyle, idx }) {
  return (
    <div className="flex justify-center main-blurb">
      <p
        className="FontSIzeScale"
        style={{
          ...fontStyle,
          textAlign: options.text_alignment,
          width: `${options.column_width * options.columns}%`,
          lineHeight: fontStyle.lineHeight + 0.2,
          fontKerning: "none",
          fontFeatureSettings: '"kern" 0',
          textRendering: "geometricPrecision",
        }}
      >
        {items[0]?.blurb ? items[0]?.blurb : " "}
      </p>
    </div>
  );
}
